import React, { useMemo, useState, forwardRef, useImperativeHandle } from 'react';
import { Row, Col } from 'react-bootstrap';
import InputGeral from '../../../../components/InputGeral/Index';
import SelectFixo from '../../../../components/SelectFixo';

const parseOpcoes = (opcoesStr) => {
    if (!opcoesStr) return [];

    return opcoesStr.split(';').map((item) => {
        const [value, text] = item.split('|');
        return { value, text };
    });
};

const AvaliacaoNotaFiscal = forwardRef(({ perguntas }, ref, desabilitaPreenchimento=false) => {
    const [respostas, setRespostas] = useState(
        perguntas.reduce((acc, p) => {
            acc[p.CodigoPergunta] = p.Valor || '';
            return acc;
        }, {})
    );

    // 📤 Expondo função pública para pegar respostas
    useImperativeHandle(ref, () => ({
        getRespostas: () => respostas,
        getNota: () => somaPonderada
    }));

    const handleChange = (codigo, novoValor) => {
        const novasRespostas = { ...respostas, [codigo]: novoValor };
        setRespostas(novasRespostas);
    };

    const somaPonderada = useMemo(() => {
        return perguntas.reduce((total, pergunta) => {
            const valor = Number(respostas[pergunta.CodigoPergunta]);
            const peso = Number(pergunta.PesoPergunta || 0);

            if (!isNaN(valor)) {
                return total + (valor * peso / 10);
            }

            return total;
        }, 0);
    }, [respostas, perguntas]);

    const somaItem = useMemo(() => {
        return perguntas.reduce((acc, pergunta) => {
            const valor = Number(respostas[pergunta.CodigoPergunta]);
            const peso = Number(pergunta.PesoPergunta || 0);
            acc[pergunta.CodigoPergunta] = !isNaN(valor) ? (valor * peso / 10) : '';
            return acc;
        }, {});
    }, [respostas, perguntas]);

    return (
        <div>
        <Row>
            <Row>
                <Col md={1} />
                <Col md={5}><h4><strong>Quesito Avaliação</strong></h4></Col>
                <Col md={3}><h4><strong>Nota</strong></h4></Col>
                <Col md={2}><h4><strong>Cálculo</strong></h4></Col>
                <Col md={1} />
            </Row>

            {perguntas.map((pergunta) => {
                const opcoes = parseOpcoes(pergunta.Opcoes);
                const codigo = pergunta.CodigoPergunta;
                const desabilitaComponente = pergunta?.Desabilitar || false;

                return (
                    <Row key={codigo}>
                        <Col md={1} />
                        <Col md={5}>
                            <label><strong>{pergunta.DescricaoPergunta}</strong></label>
                        </Col>
                        <Col md={3}>
                            {opcoes.length > 0 ? (
                                <SelectFixo
                                    options={opcoes}
                                    selectedOptionValue={opcoes.find(opt => opt.value === respostas[codigo]) || null}
                                    onChange={(selected) => handleChange(codigo, selected?.value || '')}
                                    isLabel={true}
                                    disabled={desabilitaComponente}
                                />
                            ) : (
                                <InputGeral
                                    tipo="text"
                                    value={respostas[codigo]}
                                    onChange={(e, valor) => handleChange(codigo, valor)}
                                    field={codigo}
                                    disabled={desabilitaComponente}
                                />
                            )}
                        </Col>
                        <Col md={2}>
                            <InputGeral
                                tipo="numero"
                                value={somaItem[codigo]}
                                disabled={true}
                            />
                        </Col>
                        <Col md={1} />
                    </Row>
                );
            })}
        </Row>

        {/* Nota final no canto inferior direito */}
            <Row className="mt-4">
                <Col className="d-flex justify-content-end">
                    <Col md={3}>
                        <InputGeral
                            tipo="numero"
                            label="Nota"
                            value={somaPonderada}
                            disabled={true}
                        />
                    </Col>
                </Col>
            </Row>
        </div>
    );
});

export default AvaliacaoNotaFiscal;
